import { TextField } from "@mui/material";
import { useController, UseControllerProps, Control } from "react-hook-form";

interface Props extends UseControllerProps {
    label: string;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
    control: Control<any>; // Ensure control prop is explicitly typed
    min?: number;
    max?: number;
    step?: string | number;
    defaultValue?: number | ''; // Allow customizing default value
}

export default function AppNumberInput({ control, name, label, disabled, error, helperText, min, max, step, defaultValue = '' }: Props) {
    const { field, fieldState } = useController({
        name,
        control,
        defaultValue: defaultValue,  // Use provided default or empty string
    });

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value === '' || value === null || value === undefined) {
            // Allow empty field - user can clear the value
            field.onChange('');
        } else {
            const floatVal = parseFloat(value);
            if (isNaN(floatVal)) {
                field.onChange('');
            } else {
                field.onChange(floatVal);
            }
        }
    };

    return (
        <TextField
            {...field}
            label={label}
            type="number"
            fullWidth
            variant="outlined"
            error={error || !!fieldState.error}
            helperText={helperText || fieldState.error?.message}
            onChange={handleOnChange}
            disabled={disabled}
            inputProps={{
                min: min,
                max: max,
                step: step,
            }}
        />
    );
}